export const initialState = () => ({
  type: 0,
  document: "",
  rg: "",
  generalRegistrationExempt: false,
  name: "",
  birthDate: "",
  motherName: "",
  fatherName: "",
  gender: "",
  schooled: "",
  maritalStatus: "",
  profession: "",
  professionName: "",
  contactType: {},

  companyName: "",
  companyType: "",
  companyState: 0,
  stateId: 0,
  openingDate: "",
  responsible: {
    name: "",
    cpf: ""
  },
  state: "",
  stateRegistration: "",
  exempt: false,
  contactName: "",

  email: "",
  cellphone: "",
  landline: "",
  anotherContact: "",
  whatsappContact: "",

  isSaved: false,
  clientId: "",
  isAnotherContactReturnedFilled: false,

  legalPayload: {},
  legalResponsibles: [],

  companyTypesOptions: [],
  isCompanyTypeFromBepeople: false,
  isRetroactiveCompanyType: false,
  isCompanyStateFromBepeople: false,
  customerOrigin: 0
})
